import React from 'react'
import { Helmet } from 'react-helmet-async'

function Certifications() {
  return (
    <>
       <Helmet>
                      <title>Certifications-NagsPro</title>
                      <meta name="description" content="Jump start your I.T Career with our training programs designed for both entry levels as well as seasoned
                    IT professionals."/>
                      <link rel="canonical" href="/Certifications"/>
                    </Helmet>
  
    <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
          Certifications
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              {/* <li className="breadcrumb-item">
                <a href="/Pages">Pages</a>
              </li> */}
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Certifications
              </li>
              
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
        
            {/* About Start */}
            <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/cert2.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
          
            <h6 className="section-title bg-white text-start text-primary pe-3">
            Certifications
            </h6>
            <h1 className="mb-4">
              Welcome to <span className="text-primary">NagsPro I.T Training</span>
            </h1>
            <p className="mb-4">
            Jump start your I.T Career with our training programs designed for both entry levels as well as seasoned
            IT professionals. Whether you are just starting out in the ever-changing world of I.T or you just want to
             upgrade your career, North Atlantic Global Services has a place for you. With our top notch I.T trainers
             of over 40 years combined industry experience, you can be assured of the best team to hold you by the hand
              in navigating through your I.T career. As an added value to you, our experienced admission advisor will
              be working with you to help identify your training needs and the best fit for you. And if you are new to
              I.T and wondering how you will get your first IT Job? Do not worry.
            </p>
           
            <p className="mb-4">
            NagsPro will also be assisting all students in their resume writing, interview process and securing a job.
            We have partnered with companies around the East coast to get you working immediately as long as you do well
             in your trainings and pass your certification. <b>All our trainings are hands-on, instructor led and delivered
              virtually.</b>


            </p>
          </div>
        </div>
      </div>
    </div>
    {/* About End */}

    {/* banner start */}
    <div class="banner">
    <img src="https://media.istockphoto.com/id/1190049247/photo/busy-day-group-of-multiracial-business-people-working-together-in-the-creative-co-working.jpg?s=612x612&w=0&k=20&c=qeX4zYuc555ruMM-f6adyFcMmqTP_q7_y73G4l8Vlro=" alt="Banner" class="banner-image"/>
    <div class="banner-text">
      {/* <h1>Welcome to NagsPro</h1> */}
      <p>If you are new to I.T, to help you get started, we are giving our IT Essentials Training for free when you book for any of our course.</p>
      <a href="/Contact" class="banner-btn">Contact Us</a>
    </div>
  </div>
    {/* banner End */}




    {/* cert Start */}
    {/* comptia track */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
            CompTIA Track
          </h1>
         
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
          <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/ITE.jpeg"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">IT Essential</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              IT Essentials is a foundational course offered by Cisco Networking Academy that introduces
               learners to the basics of computer hardware, software, and networking. It is designed to
                prepare individuals for entry-level IT roles and serves as a stepping stone to more advanced
                 certifications like CompTIA A+ or Cisco's own certification paths.
                 <br/><b>2 months Instructor led course</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/APLUS.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CompTIA A+</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              CompTIA A+ is a globally recognized certification that validates foundational 
              skills and knowledge required for entry-level IT professionals. It is designed 
              for individuals looking to start a career in information technology and covers 
              essential areas of computer hardware, software, and troubleshooting.
              <br/><b>3.5Months Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
             <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CompTIA+.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CompTIA Network+</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              CompTIA Network+ is a globally recognized certification that validates the foundational
               skills and knowledge required to design, configure, manage, and troubleshoot wired and
                wireless networks. It is a vendor-neutral certification offered by CompTIA (Computing
                 Technology Industry Association) and is widely respected in the IT industry.
                 <br/><b>3.5Months Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/security+.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CompTIA Security+</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              CompTIA Security+ is a globally recognized certification that validates the foundational
              knowledge and skills required to perform core security functions and pursue a career in
              cybersecurity. It is vendor-neutral, making it applicable across various technologies and
               environments. Security+ is an entry-level certification designed for IT professionals
                seeking to specialize in cybersecurity or enhance their existing knowledge of IT security.
                <br/><b>3.5Months Instructor led</b>
              </p>
             
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CySA+.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CompTIA CySA+</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              CompTIA CySA+ is an intermediate-level certification that focuses on the skills needed to detect, 
              analyze, and respond to cybersecurity threats and incidents. It is designed for IT professionals 
              who work in or aspire to work in roles such as security analysts, threat hunters, or SOC
               (Security Operations Center) analysts. CySA+ emphasizes proactive defense techniques and
                is a natural progression from the foundational CompTIA Security+ certification.
                <br/><b>3.5Months Instructor led</b>
              </p>
              
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/Linux+.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CompTIA Linux+</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              CompTIA Linux+ is a certification that validates the skills and knowledge required to work as a
               Linux system administrator. It covers the foundational skills needed to configure, manage, and
                troubleshoot Linux systems in various environments, including on-premises servers, cloud
                 infrastructure, and security systems.
                 <br/><b>4 months Instructor led</b>
              </p>
              
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* cisco track */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
          CISCO Track
          </h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CCNA.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CCNA</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              CCNA is an entry-level IT certification offered by Cisco, designed to validate
              foundational networking knowledge and skills. It is one of the most popular and
            respected certifications in the IT industry, serving as a gateway for individuals
            pursuing careers in networking, cybersecurity, and IT infrastructure.
                 <br/><b>4 months Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CiscoCyberOps.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">Cisco Certified CyberOps <br/>(Associate)</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Cisco Certified CyberOps Associate certification is designed for individuals pursuing 
              a career in cybersecurity operations. This certification validates foundational knowledge 
              and skills required to work in a Security Operations Center (SOC) as an entry-level 
              cybersecurity analyst. It focuses on core cybersecurity concepts, network security, 
              and monitoring for threats.
              <br/><b>3 Months Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CCNP.jpg"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CCNP</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              CCNP (Cisco Certified Network Professional) is a mid-level certification offered by Cisco 
              for IT professionals looking to advance their networking knowledge and skills. It is designed 
              for individuals who already have a solid foundation in networking (such as those with a CCNA 
              certification) and want to specialize further in specific areas of networking.
                 <br/><b>4 Months Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
     
        </div>
      </div>
    </div>

      {/* AWS Track */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
          AWS Track
          </h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/AWSPractitioner.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">AWS Cloud Practitioner</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The AWS Certified Cloud Practitioner certification is an entry-level certification 
              designed for individuals seeking to demonstrate their overall knowledge of Amazon 
              Web Services (AWS) cloud concepts, independent of specific technical roles. It validates 
              a foundational understanding of AWS services, architecture, and best practices.
                 <br/><b>6 Weeks Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/AWSSolution.webp"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">AWS Solution Architect<br/> (Associate)</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The AWS Certified Solutions Architect - Associate certification is designed for individuals 
              who have experience in designing distributed systems and applications on the AWS platform. 
              It validates your ability to design and deploy scalable, fault-tolerant, and cost-effective 
              systems in the AWS cloud.
              <br/><b>3.5 Months Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/AWSPro.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">AWS Solution Architect (Professional)</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The AWS Certified Solutions Architect - Professional certification is an advanced-level credential 
              for experienced cloud architects. It demonstrates expertise in designing and deploying scalable, 
              fault-tolerant, and secure applications on the AWS platform. This certification validates your 
              ability to handle complex architectural solutions and optimize performance in cloud environments.
                 <br/><b>3.5 Months Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
     
        </div>
      </div>
    </div>

      {/* ISACA Track */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
          ISACA Track
          </h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CISA.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CISA</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Certified Information Systems Auditor (CISA) certification is a globally recognized 
              credential offered by ISACA. It is designed for professionals who audit, control, monitor, 
              and assess an organization's information technology and business systems. The certification 
              validates expertise in ensuring that IT and business systems are secure, efficient, and compliant 
              with industry standards.
                 <br/><b>3 Months Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CRISC.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CRISC</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Certified in Risk and Information Systems Control (CRISC) certification, offered by ISACA, 
              is a globally recognized credential designed for professionals who identify, evaluate, manage, 
              and monitor IT and business risks. It demonstrates expertise in aligning IT risk management with 
              overall enterprise objectives.
              <br/><b>6 Weeks Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CISM.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CISM</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Certified Information Security Manager (CISM) certification, offered by ISACA, 
              is a globally recognized credential for professionals managing, designing, and assessing 
              enterprise information security programs. CISM emphasizes business alignment, making it 
              ideal for individuals aiming to bridge the gap between cybersecurity and business objectives.


                 <br/><b>6 Weeks Instructor led</b>
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
     
        </div>
      </div>
    </div>


     {/* (ISC)² Track */}
     <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
          (ISC)² Track
          </h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/SSCP.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">SSCP
              <br/><b>8 Weeks Instructor led</b>
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Systems Security Certified Practitioner (SSCP) certification, offered by (ISC)², 
              is a globally recognized credential designed for IT professionals responsible for 
              implementing, monitoring, and managing IT infrastructure in accordance with cybersecurity 
              best practices and policies. It validates technical skills and practical knowledge in 
              system security.
                 {/* <br/><b>8 Weeks Instructor led</b> */}
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CCSP.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CCSP
              <br/><b>8 Weeks Instructor led</b>
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Certified Cloud Security Professional (CCSP) is a globally recognized certification 
              offered by (ISC)² for IT and cybersecurity professionals specializing in cloud security. 
              It validates advanced knowledge and practical experience in securing cloud environments 
              and applications, aligning with industry best practices and standards.
              {/* <br/><b>8 Weeks Instructor led</b> */}
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CAP.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CAP
              <br/><b>7 Weeks Instructor led</b>
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Certified Authorization Professional (CAP) is a globally recognized certification offered by 
              (ISC)² for IT and cybersecurity professionals specializing in security authorization and risk management. 
              The CAP credential validates advanced knowledge and skills in implementing, managing, and authorizing 
              information systems within a risk management framework.
                 {/* <br/><b>7 Weeks Instructor led</b> */}
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>

          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/CISSP.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">CISSP
              <br/><b>7 Weeks Instructor led</b>
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Certified Information Systems Security Professional (CISSP) is a globally recognized 
              certification offered by (ISC)². It validates a professional's expertise in designing, 
              implementing, and managing a best-in-class cybersecurity program. CISSP is widely considered 
              a gold standard in the field of cybersecurity and is trusted by organizations worldwide.
                 {/* <br/><b>7 Weeks Instructor led</b> */}
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
     
        </div>
      </div>
    </div>


      {/* Frameworks/Standards */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
          Frameworks/Standards
          </h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/TOGAF.jpeg"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">TOGAF ®
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              TOGAF®, developed by The Open Group, is a globally recognized framework for enterprise architecture. 
              It provides a detailed approach for designing, planning, implementing, and governing an enterprise 
              information technology architecture.
                 {/* <br/><b>8 Weeks Instructor led</b> */}
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/ITIL.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">ITIL
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              ITIL® is a globally recognized framework for IT service management (ITSM) 
              that helps organizations deliver high-quality IT services aligned with business needs. 
              Developed by AXELOS, ITIL® provides a systematic approach to managing IT services 
              throughout their lifecycle.
              {/* <br/><b>8 Weeks Instructor led</b> */}
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
       

        </div>
      </div>
    </div>

      {/* Microsoft Track */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
          Microsoft Track
          </h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/MicrosoftProfessional.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">Microsoft Certified Professional (MCP)</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Microsoft Certified Professional (MCP) certification is a foundational 
              credential offered by Microsoft to validate an individual's expertise in Microsoft 
              technologies, platforms, and tools. Although the MCP certification was part of 
              Microsoft's earlier certification paths, it has been retired and replaced by newer 
              certifications under the Microsoft Learn Certification Program.
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/MicrosoftAssociate.webp"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">Microsoft Certified Solution Associate (MCSA)</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Microsoft Certified Solutions Associate (MCSA) certification was an industry-recognized credential 
              offered by Microsoft to validate foundational skills and knowledge in Microsoft technologies. It was a 
              stepping stone for IT professionals aiming to achieve higher-level certifications like the Microsoft 
              Certified Solutions Expert (MCSE).
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/MCSE.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">Microsoft Certified Solution Expert (MCSE)</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Microsoft Certified Solutions Expert (MCSE) certification was a globally recognized 
              credential designed for IT professionals with advanced skills in designing, implementing, 
              and managing Microsoft solutions and infrastructure. It validated expertise in a wide range 
              of Microsoft technologies, making it a prestigious and sought-after certification.
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>

          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/Azure.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">Azure Administration (AZ 104)</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Microsoft Azure Administrator (AZ-104) certification exam is designed for IT professionals 
              responsible for managing and monitoring an organization’s Microsoft Azure environment. 
              This certification validates the skills required to implement, manage, and monitor identity, 
              governance, storage, compute, and virtual networks in a cloud environment.
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
     
        </div>
      </div>
    </div>

     {/* Web Development and Technologies */}
     <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
          Web Development and Technologies
          </h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/webdev.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">HTML, PHP, JavaScript, MySQL, MS SQL, Web Frameworks...
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              Web development encompasses the creation and maintenance of websites, applications, 
              and platforms for the internet or an intranet. It integrates multiple technologies 
              to deliver functional, scalable, and visually appealing user experiences.
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
       
        </div>
      </div>
    </div>

      {/* Project Management Track */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h1 className="  text-center text-primary px-3">
          Project Management Track
          </h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/PMP.png"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">PMP
              <br/><b>6 Weeks Instructor led</b>
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              The Project Management Professional (PMP) is a globally recognized certification 
              offered by the Project Management Institute (PMI). It validates a professional's 
              ability to lead and manage projects effectively across various industries, methodologies, 
              and organizational structures.


              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
               <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/Prince2.jpeg"
                alt=""
                style={{ objectFit: "cover" }}
              />
              </div>
              <h5 className="mt-4">Prince2 ®
              <br/><b>6 Weeks Instructor led</b>
              </h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
              PRINCE2 is a structured project management methodology that emphasizes the organization 
              and control of projects. It is widely recognized and used across the globe, especially 
              in the UK and Europe. PRINCE2 provides a clear, flexible, and scalable approach for managing 
              projects, regardless of size or complexity.
              {/* <br/><b>8 Weeks Instructor led</b> */}
              </p>
              <a href="/pricing" class="banner-btn">Get Pricing Information</a>
            </div>
          </div>
       

        </div>
      </div>
    </div>

    {/* cert Start */}

    </div>
    </>
  )
}

export default Certifications